import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession, useSessionBootstrap } from '@/lib/session';
import { Sidebar } from './Sidebar';

export const AuthGuard = () => {
  useSessionBootstrap();
  const { session, loading } = useSession();
  const location = useLocation();

  useEffect(() => { /* no-op; bootstrap does the work */ }, []);

  if (loading) {
    return (
      <div className="flex h-svh items-center justify-center">
        <div className="size-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }
  if (!session) {
    return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
  }
  return (
    <div className="flex h-svh">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};
